import { LoginBody_Response } from '../Login'

interface GoogleAuthAPI_POST_Body {
  google_token: string
}

export namespace GoogleAuthAPI {
  export namespace POST {
    export type Body = GoogleAuthAPI_POST_Body
    export type Response = LoginBody_Response
  }

  export function post() {
    return { url: `/rusty/google_login`, method: 'post' }
  }
}
